import React from 'react'
import { Card, CardMedia, Box, Typography, makeStyles, CardContent } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../hooks/useAuth';
import { useAPI } from '../../../hooks/useAPI';


const ConciergeServiceCard = (props) => {

  const { service, label, image, onClick, description } = props
  const theme = useTheme()



  return (
    <Card sx={{ maxWidth: 280, cursor: 'pointer', position: 'relative' }} onClick={onClick}>
      <CardMedia
        sx={{ height: 240, backgroundSize: label.toLowerCase() === "ai production" ? 'contain' : 'cover', backgroundColor: label.toLowerCase() === "ai production" ? '#29296d' : 'transparent' }}
        image={image}
      />
      <div style={{ position: 'absolute', top: 190, left: 0, right: 0, background: 'rgba(0, 0, 0, 0.5)', padding: '8px', textAlign: 'center' }}>
        <Typography variant="h5" color="white">
          {label.toUpperCase()}
        </Typography>
      </div>
      <CardContent style={{}}>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Card>

  )
}

export default ConciergeServiceCard